export default {
  version: 'Version',
  'build-date': 'Build date',
  navbar: {
    logOut: 'Log Out',
    language: 'Change language',
    screenfull: 'screenfull',
    theme: 'theme'
  },
  login: {
    title: 'ALTURA',
    user: 'User',
    password: 'Password',
    rememberme: 'Remember me',
    signin: 'Sign In',
    undefined: 'Authorization error',
    AuthenticationError: {
      wrongUsernameOrPassword: 'Wrong username or password'
    },
    ConcurrentSessionControlAuthenticationStrategy: {
      'exceededAllowed': 'Exceeded allowed concurrent sessions'
    }
  },
  user: {
    'hello-message-X': 'Welcome {name}!',
    'my-roles': 'My roles'
  },
  common: {
    addButton: 'Add',
    search: 'Search...',
    save: 'Save',
    deleteQuestion: 'Are you sure?',
    delete: 'Delete',
    apply: 'Apply',
    emptyList: 'No data found',
    id: 'ID',
    code: 'Code',
    type: 'Type',
    displayName: 'Display name',
    description: 'Description',
    value: 'Value',
    updated: 'Updated',
    version: 'Version',
    export: 'Export',
    terminate: 'Terminate',
    restart: 'Restart',
    dropXclFile: 'Drop excel file here or',
    of: 'of',
    select: 'Select',
    selected: 'Selected',
    approve: 'Approve',
    reject: 'Reject',
    refresh: 'Refresh',
    editMode: 'Edit mode',
    recent: 'Recent',
    'message-box': {
      'submit': 'Submit',
      'cancel': 'Cancel',
      'confirm-common-label': 'Confirm action'
    },
    flightDate: 'Flight date',
    'process-diagram': 'Process diagram',
    attention: 'Attention',
    show: 'Show',
    hide: 'Hide',
    'preview-title-x': 'Предпросмотр: {label}'
  },

  // ************
  main: {
    title: 'Main',
    TheGodchildren1: {
      title: 'The Godchildren 1'
    },
    TheGodchildren2: {
      title: 'The Godchildren 2'
    },
    ProcessDefinitions: {
      title: 'Process Definitions'
    },
    FlightList: {
      title: 'Flight list'
    }
  },

  'flight-orders': {
    'dev-title': '[DEV] Flight Orders',
    'title': 'Flight Orders',
    'order': 'Order',
    'Initiator': 'Initiator',
    'Author': 'Author',
    'SelectInitiator': 'Select Initiator',
    'SelectDepPort': 'Select Departure',
    'SelectArrPort': 'Select Arrival',
    'DepPort': 'Departure',
    'ArrPort': 'Arrival',
    'depDate': 'Departure Date',
    'dateTo': 'Arrival Date',
    'no-order-items-in-uploaded-file': 'No order items found in uploaded file',
    'no-paxes-in-uploaded-file': 'No paxes in uploaded file',
    'choose-flight-order': 'Choose flight order',
    'totalOrderItems': 'Order items:',
    'createdBy': 'Created by',
    'source': 'Source:',
    'addPassenger': 'Add passenger',
    'addCargo': 'Add cargo',
    'pax-list-title': 'Passengers',
    'cargo-list-title': 'Cargo',
    'all-matches': 'All matches',
    'no-orders-found': 'No flight orders found',
    'header-persons': 'Persons',
    'header-cargoes': 'Cargoes',
    'flight-date': 'Flight date',
    'priority-up': 'Up priority',
    'priority-down': 'Down priority',
    'show-process': 'Process diagram',
    'delete-item': 'Delete',
    group: {
      'd-t-k': 'Date-From-To',
      'd-org': 'Date-Organization',
      'no-group': 'No grouping'
    },
    filter: {
      'flight-date-range': 'Departure date',
      'flight-date-range-start': 'From',
      'flight-date-range-end': 'To',
      'flight-date-from': 'Departure from',
      'flight-date-to': 'Departure to',
      'free-search': 'Search',
      'full-match': 'Full match',
      'organization': 'Organization',
      'initiator': 'Initiator',
      'priority': 'Priority',
      'priority-high': 'High',
      'priority-normal': 'Normal',
      'priority-low': 'Low',
      'order-type': 'Type',
      'order-type-person': 'Pax',
      'order-type-cargo': 'Cargo',
      'order-type-all': 'All',
      'order-planned': 'Planned',
      'order-not-planned': 'Not planned'
    },
    'paxList': {
      'num': '#',
      'fullName': 'Full name',
      'lastName': 'Last name',
      'firstName': 'First name',
      'middleName': 'Middle name',
      'docNum': 'Document number',
      'cabinBaggage': 'Cabin baggage',
      'depPort': 'From',
      'arrPort': 'To',
      'route': 'Route',
      'birthDate': 'Birth date',
      'organization': 'Organization',
      'contacts': 'Contacts',
      'email': 'E-mail',
      'mvz': 'MVZ(SPP)',
      'timeFrom': 'Time from',
      'status': 'Status',
      'transportType': 'Transport Type',
      'placeCount': 'Count of cargo places',
      'cargoName': 'Cargo name',
      'dimensions': 'Dimensions',
      'weight': 'Mass, kg',
      'packType': 'Type of packaging',
      'curatorContacts': 'Curator\'s contact',
      'curatorEmail': 'Curator\'s E-mail',
      'markers': 'Markers',
      'priority': 'Priority',
      'priorityLow': 'low',
      'priorityNormal': 'normal',
      'priorityHigh': 'high',
      'transfer': 'Transfer',
      'withTransfer': 'With transfer',
      'withoutTransfer': 'Without transfer'
    },
    processState: {
      'APPROVING': 'Approving',
      'SECURITY-APPROVED': 'Approved by Security',
      'CURATOR-APPROVED': 'Approved by curator',
      'BLACK-LIST-REJECTED': 'Black list rejected',
      'FLIGHT-DATE-TIMEOUT': 'Flight date timeout',
      'PROCESSING': 'Approved',
      'PLANNED': 'Planned',
      'REJECTED': 'Rejected',
      'FINISHED': 'Finished',
      'noState': 'N/D'
    },
    'notify': {
      'title-order-group-saved': 'Order Group',
      'new-order-group-saved-X': 'Order group saved with id {groupId}',
      'order-group-saved': 'Order group saved',
      'order-group-published': 'Order group published',
      'order-edit-cannot-enable-title': 'Cannot enable edit mode',
      'order-edit-cannot-enable-text': 'Another order is being edited',
      'order-edit-success': 'Successful editing',
      'order-edit-has-been-edit': 'Order edit has been edited',
      'order-edit-failed': 'Editing was failed',
      'order-edit-has-not-been-edit': 'Order edit has not been edited',
      'order-edit-success-remove': 'Successful removing',
      'order-edit-has-been-remove': 'Order edit has been removed',
      'order-edit-failed-remove': 'Removing was failed',
      'order-edit-has-not-been-remove': 'Order edit has not been removed',
      'uploaded-message': 'Orders uploaded',
      'deleted-many-message': 'Orders have been deleted',
      'deleted-one-message': 'Order has been deleted'
    },
    'message-box': {
      'submit': 'Submit',
      'cancel': 'Cancel',
      'remove-group-label': 'Confirm',
      'remove-group-text': 'Delete order group and all its orders?'
    }
  },
  freight: {
    'title': 'Freights manage',
    'approve-title': 'Freights approve',
    'finalize-title': 'Freights finalize',
    'create': 'Create',
    'route': 'Route:',
    'empty-route': 'Empty route',
    'last-update-x': 'updated: {date}',
    'remove-all-legs': 'Clear route',
    'delete-freight': 'Delete freight',
    'auto-update-off': 'Autoupdate is OFF',
    'auto-arrange': {
      'replace-all': 'Auto arrange: replace all',
      'append': 'Auto arrange: append',
      'append-initial-locations': 'Auto arrange: append with initial ports',
    },
    'apply-arrange': 'Apply arrange',
    'cancel-arrange': 'Cancel arrange',
    'auto-append-orders': 'Append left orders',
    'remove-last-leg': 'Remove last leg',
    'add-leg': 'Add leg',
    'remove-order-item': 'remove',
    'remove-order-item-not-departed': 'remove, not departed',
    'duration': 'Duration',
    filter: {
      'portDep': 'From',
      'portArr': 'To'
    },
    'message-box': {
      'submit': 'Confirm',
      'cancel': 'Cancel',
      'remove-route-text': 'Remove all legs?',
      'delete-freight-text': 'Remove freight?',
      'remove-existed-freights-before-arrange': 'Existed arrange on date will be deleted.'
    },
    notify: {
      'error-on-save-changes': 'Error on save freight changes',
      'process-started': 'Process started',
      'approve-result-submitted': 'Approve decision submitted',
      'finalized-freight': 'Freight request is finished'
    },
    'send-to-approve': 'To approve',
    'show-process': 'Process diagram',
    'freight-state': 'State',
    'action-approve': 'Approve',
    'action-reject': 'Reject',
    'action-finalize': 'Finalize',
    'documents': 'Documents',
    'report-main': 'Freight request',
    'report-details': 'Persons and cargoes',
    'change-flight-date': 'Change flight date',
    processState: {
      NEW: 'New',
      APPROVING: 'Approving',
      PROCESSING: 'Processing',
      REJECTED: 'Rejected',
      FINISHED: 'Finished'
    }
  },
  'flight-order-groups': {
    security: {
      title: 'Security service'
    },
    final: {
      title: 'Final approving'
    }
  },
  'special-lists': {
    'title': 'Special lists',
    'white-list': 'White list',
    'black-list': 'Black list',
    'pax': {
      'code': 'Code',
      'passNum': 'Pass num',
      'requestNum': 'Request num',
      'organization': 'Organization',
      'fullName': 'Full name',
      'birthDate': 'Birth date',
      'position': 'Position',
      'subcontractor': 'Subcontractor',
      'passDateFrom': 'Issue date',
      'passDateTo': 'Date to'
    },
    'notify': {
      'saved-message': 'File successfully applied'
    }
  },
  administration: {
    title: 'Administration',
    settings: {
      title: 'Settings',
      name: 'Name',
      description: 'Description',
      value: 'Value',
      edit: 'Edit',
      confirm: 'Confirm',
      decline: 'Decline'
    },
    users: {
      title: 'Users',
      fullName: 'Full name',
      login: 'Login',
      role: 'Roles',
      email: 'E-mail',
      phone: 'Phone',
      ports: 'Ports',
      edit: 'Edit',
      editPassword: 'Edit password',
      deletion: 'Deletion',
      delete: 'Delete',
      deleteModalText: 'Are you sure you want to delete the user',
      cancel: 'Cancel',
      changePassword: 'Change password',
      newPasswordGeneration: 'New password generation',
      generateNewPassword: 'Generate new password',
      generateNewPasswordFor: 'Generate new password  for',
      changePasswordModalText: 'New password for',
      submit: 'Submit',
      changeUser: 'Change user',
      addUser: 'Add user',
      add: 'Add',
      freeSearch: 'Free search',
      invalidEmail: 'Invalid email',
      invalidPhone: 'Invalid phone number',
      existLogin: 'Such login exists',
      requiredField: 'Required field',
      maxLength: 'Input limit exceeded',
      useLatin: 'Use latin alphabet',
      companies: 'Companies',
      organization: 'Organization'
    },
    notification: {
      title: 'Notification Settings',
      sms: 'SMS',
      email: 'Email',
      push: 'Push',
      eventsRoles: 'Events\\Roles',
      header: 'Message theme',
      message: 'Message',
      edit: 'Edit',
      checkboxErrorTitle: 'Error',
      checkboxErrorMessage: 'Cannot save with empty fields'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js